'use strict';

const env: any = (window as any).__env || {};

export const sep = '/';
export const version = '22.3.1';
export const baseApi = env.baseApi || 'http://localhost:8081';
export const merchantApi = env.merchantApi || 'http://localhost:8085';
